import React from 'react';
import { Row, Col } from 'react-bootstrap';
import MobileUnitPriceEditDelete from './MobileUnitPriceEditDelete';

interface Props {
  /** vendor name and showPkgPrice properties */
  vendor?: {
    vendorName: string;
    rateDisplayOption: {
      showPkgPriceOnly: boolean;
    };
  };
  /** the unit item being interacted with */
  item: any,
  /** whether the quote has been created yet */
  quoteStatus?: number;
  editable?: boolean,
  showPricing: boolean,
  getPriceString: () => string;
  editItem: (item: any) => void;
  removeItem: (item: any) => void;
  children?: any;
}

const MobileUnitTabDetails: React.FC<Props> = ({
  vendor,
  item,
  quoteStatus,
  editable,
  showPricing,
  getPriceString,
  editItem,
  removeItem,
  children,
}) => {
  return (
    <Col className="d-md-none">
      <Row className="w-100 mt-3">
      {/** {Left-Justified Variant}
        <Col xs={12}>
          {children}
        </Col>
        {quoteStatus === undefined && (editable ?? true) && (
          <MobileUnitPriceEditDelete
            vendor={vendor}
            showPricing={showPricing}
            getPriceString={getPriceString}
            editItem={editItem}
            removeItem={removeItem}
            item={item}
          />
        )}
      </Row>
      */}
      {/** {Right-Justified Variant or Icon Horizontal Variant}
        <Col xs={8}>
          {children}
        </Col>
        {quoteStatus === undefined && (editable ?? true) && (
          <Col xs={4} className="d-flex flex-column align-items-end justify-content-between" style={{ paddingRight: '0px' }}>
            <p className="m-0 p-0 font-weight-bold green-text">
              {!vendor?.rateDisplayOptions.showPkgPriceOnly && showPricing ? getPriceString() : "Package Price"}
            </p>
            <MobileUnitPriceEditDelete
              editItem={editItem}
              removeItem={removeItem}
              item={item}
            />
          </Col>
        )} */}
        {/** {Icon Vertical Variant} */}
        <Col xs={8}>
          {children}
        </Col>
        {quoteStatus === undefined && (editable ?? true) && (
          <Col xs={4} className="d-flex flex-column align-items-end justify-content-between" style={{ paddingRight: '0px' }}>
            <MobileUnitPriceEditDelete
              vendor={vendor}
              showPricing={showPricing}
              getPriceString={getPriceString}
              editItem={editItem}
              removeItem={removeItem}
              item={item}
            />
          </Col>
        )}
        {quoteStatus !== undefined && (
          <Col xs={4} style={{ paddingRight: '0px' }}>
            <div style={{alignItems: 'end', display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between'}}>
              <p className="m-0 p-0 font-weight-bold green-text">
                {!vendor?.rateDisplayOption.showPkgPriceOnly && showPricing ? getPriceString() : "Package Price"}
              </p>
            </div>
          </Col>
        )}
        
      </Row>
      <Row className="d-flex flex-row mobile-divider" />
    </Col>
  );
};

export default MobileUnitTabDetails;